import DewarService from 'business/services/DewarService';
import PuckService from 'business/services/PuckService';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { setAllPucks } from 'redux/reducers/puckReducer';
import { PuckDewarContainerView } from '../puck/constants';
import { setAllDewars } from 'redux/reducers/dewarReducer';
import { getPlainDewars, getPlainPucks } from 'transformers/synchrotronTrip';

const handleBackToPreviousScreen = (setHandleOnTabBackPress, setContentView, view) => {
  setHandleOnTabBackPress(() => () => {
    setContentView(view);
  });
};

export const useAttachSidePanelBackButton = (
  setHandleOnTabBackPress: Dispatch<SetStateAction<() => void>>,
  setContentView: (view: PuckDewarContainerView) => void,
  view: PuckDewarContainerView,
) => {
  useEffect(() => {
    if (handleBackToPreviousScreen) {
      handleBackToPreviousScreen(setHandleOnTabBackPress, setContentView, view);
    }
  }, [setHandleOnTabBackPress]);
};
export const useFetchAllEnabledDewarsWithOccupancyByTrip = (tripId: number) => {
  const dispatch = useRMDispatch();
  const loadAllDewars = async () => {
    const dewarService = new DewarService();
    const allEnabledDewars = (await dewarService.getAllDewars()).filter(
      (dewar) => dewar.enable === true,
    );
    dispatch(setAllDewars(getPlainDewars(allEnabledDewars)));
  };

  useEffect(() => {
    loadAllDewars();
  }, []);
};

export const useFetchAllEnabledPucksWithOccupancyByTrip = (tripId: number) => {
  const dispatch = useRMDispatch();
  const loadAllPucks = async () => {
    const puckService = new PuckService();
    const allEnabledPucks = (
      await puckService.getAllPucksWithOccupancyByTripId(tripId)
    ).filter((puck) => puck.enable === true);
    dispatch(setAllPucks(getPlainPucks(allEnabledPucks)));
  };

  useEffect(() => {
    loadAllPucks();
  }, []);
};
